import { render, staticRenderFns } from "./UserAccountProfilePassword.vue?vue&type=template&id=7a4257b4&"
import script from "./UserAccountProfilePassword.vue?vue&type=script&lang=js&"
export * from "./UserAccountProfilePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports